import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import { TrainingDetail } from '~/training/types';
import EmptyMessage from '../EmptyMessage';
import MachineItem from './MachineItem';

export interface LinkedMachinesProps {
  excavators: TrainingDetail['excavators'];
}

export type LinkedMachinesComponent = React.FC<LinkedMachinesProps>;

const LinkedMachines: LinkedMachinesComponent = ({ excavators }) => {
  const { t } = useTranslation('training');

  if (!excavators?.length) {
    return <EmptyMessage message={t('noMachinesFound')} />;
  }

  return (
    <ul className={classes['machine-list']}>
      {excavators.map((excavator) => (
        <MachineItem key={excavator.id} excavator={excavator} />
      ))}
    </ul>
  );
};

export default LinkedMachines;
